// BL-177 Step 2o: the small grey "why the AI was quiet" lines under a thread's texts. The reasons already exist on each text's mirror event;
// bl177_ai_thread_notes hands them back (read-only, only to people who may see the thread). Nothing here writes anything.
import { useEffect, useState } from 'react';

const SETTLE_MS = 3000;

/** { [event id]: { kind, note } } for one conversation. Re-read when the thread changes, and once more shortly after (the hand-off decides about a second after the text lands). */
export function useAiThreadNotes({ client, sessionId = null, refreshKey = '' } = {}) {
    const [notes, setNotes] = useState({});
    useEffect(() => {
        if (!sessionId || typeof client?.rpc !== 'function') { setNotes({}); return undefined; }
        let active = true;
        const load = async () => {
            try {
                const { data, error } = await client.rpc('bl177_ai_thread_notes', { p_session_id: sessionId });
                if (!active || error || !Array.isArray(data)) return;
                setNotes(Object.fromEntries(data.filter((row) => row?.event_id && row?.note).map((row) => [row.event_id, { kind: row.kind, note: row.note }])));
            } catch {
                // The lines are a convenience; the thread works without them.
            }
        };
        load();
        const timer = setTimeout(load, SETTLE_MS);
        return () => { active = false; clearTimeout(timer); };
    }, [client, sessionId, refreshKey]);
    return notes;
}
